import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useFTUWizard } from '../../context';
import { ReactComponent as WizardIcon } from 'assets/illustrations/ssr-wizard.svg';
import { ReactComponent as RightArrowIcon } from 'assets/ss-icons/right-arrow.svg';
import { ReactComponent as CircleCheckedIcon } from 'assets/ss-icons/circle-checked.svg';
import { useRetailer } from 'utils/hooks';

export default function Header({ isStarted = false, isCompleted = false }) {
  const { getStoreProperty } = useRetailer();
  const { onToggle } = useFTUWizard();

  const storeName = getStoreProperty('store_name', '');

  return (
    <UiKit.Card.Body>
      <UiKit.Flex
        gap={28}
        align="center"
        justify="space-between"
        className="py-2"
      >
        <UiKit.Flex direction="column" gap={20} align="flex-start">
          <UiKit.Flex direction="column" gap={8}>
            <UiKit.Title size="md" weight="normal">
              <If
                test={isCompleted}
                otherwise="Welcome to ShipStation Returns!"
              >
                You're all set!
              </If>
            </UiKit.Title>
            <UiKit.Title>
              <If
                test={isCompleted}
                otherwise={`Setup your Returns workflow in just a few steps for your ${storeName} store`}
              >
                Returns are set up for {storeName}&nbsp;
                <span role="img" aria-label="celebration">
                  🎉
                </span>
              </If>
            </UiKit.Title>
          </UiKit.Flex>
          <If test={!isCompleted}>
            <UiKit.Button onClick={onToggle} variant="promotional" size="xl">
              {isStarted ? 'Finish' : 'Start'} Setup
              <RightArrowIcon />
            </UiKit.Button>
          </If>
        </UiKit.Flex>
        <div className={styles.illustration}>
          <If test={isCompleted}>
            <div className={styles.checkIcon}>
              <CircleCheckedIcon />
            </div>
          </If>
          <WizardIcon />
        </div>
      </UiKit.Flex>
    </UiKit.Card.Body>
  );
}
